/* eslint-disable tailwindcss/no-arbitrary-value */
import { IconProps } from '@ui/components/elements/icon/Icon';
import {Avatar, AvatarProps } from '@ui/components/tokens/avatar/Avatar';
import { cn } from '@ui/lib/utils';
import { Icon } from '../../elements/icon/Icon';
import { Title1, Title2, Title4 } from '../../tokens/typography/StyledText';
import { ReactNode } from 'react';

const containerClassName =
  'w-full inline-flex items-center justify-start gap-4 self-stretch';
interface HeadlingCommonProps {
  headline: {
    content: ReactNode;
    className?: string;
  };
  size?: 'sm' | 'md' | 'lg' | 'xs';
  position?: 'start' | 'end';
}

export interface HeadlineIconProps extends HeadlingCommonProps {
  icon?: Pick<IconProps, 'fileName' | 'className'>;
  illustration?: unknown;
}

interface HeadlineAvatarProps extends HeadlingCommonProps {
  avatar?: Omit<AvatarProps, 'size'>;
}

export type HeadlineProps = HeadlineIconProps | HeadlineAvatarProps;

const sizeOptionsMap = {
  xs: { StyledText: Title4, iconSize: 'md' as const },
  sm: { StyledText: Title4, iconSize: 'lg' as const },
  md: { StyledText: Title2, iconSize: 'xl' as const },
  lg: { StyledText: Title1, iconSize: 'xxl' as const },
};

export const Headline = ({
  headline: { content, className },
  position = 'start',
  size = 'md',
  ...rest
}: HeadlineProps) => {
  const TitleComponent = sizeOptionsMap[size];

  const flexDirection =
    position === 'start'
      ? 'flex-row justify-start'
      : 'flex-row-reverse justify-between';
  if ('avatar' in rest) {
    return (
      <div className={cn(containerClassName, flexDirection)}>
        <Avatar {...{ ...(rest.avatar as AvatarProps), size }} />
        <TitleComponent.StyledText className={className}>
          {content}
        </TitleComponent.StyledText>
      </div>
    );
  }

  if ('icon' in rest && rest.icon) {
    if (!rest.icon.fileName) {
      throw new Error('Icon is required');
    }

    if (rest.illustration) {
      throw new Error('Illustration not yet implemented!');
    }

    return (
      <div className={cn(containerClassName, flexDirection)}>
        <Icon {...rest.icon} size={sizeOptionsMap[size].iconSize} />
        <TitleComponent.StyledText className={className}>
          {content}
        </TitleComponent.StyledText>
      </div>
    );
  }

  return (
    <TitleComponent.StyledText className={className}>
      {content}
    </TitleComponent.StyledText>
  );
};
